import React from 'react';
import { useSelector } from 'react-redux';

// TS type
import { RootState } from '@redux/store';

// shared component
import IconFC from '@component/Common/IconFC';

// plugin
import { useTranslation } from 'react-i18next';

const Tags: React.FC<any> = (props) => {
    const { t } = useTranslation();
    const { GDetail } = useSelector((state: RootState) => state.GDS);

    return (
        <div className="tags">
            <div className="tagTitle">{t('noTHSR.tags.aboutPlan')}</div>
            <div className="tagContent">
                {GDetail?.Tag.map((tag, i) => {
                    return (
                        <div className="tag" key={i}>
                            <IconFC iconType={tag.Type} />
                            <span>{tag.Text}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Tags;
